/* Velvære offer-page sections — shared behaviour. No dependencies.
   Tiers + add to cart, tabs, gallery, Before & Afters slider, reviews load-more, countdown bar, reservation timer, ship-by date, sticky bar. */
(function () {
  /* Runs once per page even when several sections include this script tag, and re-runs for a section the theme editor reloads. Every init marks its element so nothing is wired twice. */
  if (window.__vvOffer) { return; }
  window.__vvOffer = true;
  function qs(root, s) { return root.querySelector(s); }
  function qsa(root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fresh(list) { return list.filter(function (e) { if (e.__vvInit) return false; e.__vvInit = true; return true; }); }

  function init(root) {
    var Q = function (s) { return fresh(qsa(root, s)); };
    var one = function (s) { var e = qs(root, s); if (!e || e.__vvInit) return null; e.__vvInit = true; return e; };

  /* Buy block: tier selection + add to cart / link + price in button */
  Q('[data-vv-buy]').forEach(function (buy) {
    var tiers = qsa(buy, '[data-vv-tier]');
    var btn = qs(buy, '[data-vv-cta]');
    var form = qs(buy, 'form[data-vv-form]');
    var idInput = form ? qs(form, 'input[name="id"]') : null;
    var qtyInput = form ? qs(form, 'input[name="quantity"]') : null;
    function select(t) {
      tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); x.setAttribute('aria-checked', x === t ? 'true' : 'false'); });
      if (btn) {
        var label = t.getAttribute('data-vv-cta-label');
        var tx = qs(btn, '[data-vv-cta-text]');
        if (label && tx) tx.textContent = label; else if (label) btn.textContent = label;
      }
      if (idInput) idInput.value = t.getAttribute('data-vv-variant') || idInput.value;
      if (qtyInput) qtyInput.value = t.getAttribute('data-vv-qty') || '1';
      buy.setAttribute('data-vv-sel-qty', t.getAttribute('data-vv-qty') || '1');
      buy.setAttribute('data-vv-link', t.getAttribute('data-vv-link') || '');
      var sumTotal = qs(buy, '[data-vv-sum-total]'), sumCompare = qs(buy, '[data-vv-sum-compare]'), sumName = qs(buy, '[data-vv-sum-name]');
      if (sumTotal) sumTotal.textContent = t.getAttribute('data-vv-total') || '';
      if (sumCompare) sumCompare.textContent = t.getAttribute('data-vv-compare') || '';
      if (sumName) sumName.textContent = t.getAttribute('data-vv-name') || '';
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(t); } });
    });
    var pre = tiers.filter(function (t) { return t.hasAttribute('data-vv-default'); })[0] || tiers[0];
    if (pre) select(pre);
    if (btn) btn.addEventListener('click', function (e) {
      var link = buy.getAttribute('data-vv-link');
      if (link) { e.preventDefault(); window.location.href = link; return; }
      var cartPage = buy.getAttribute('data-vv-cart-page');
      if (cartPage) { e.preventDefault(); window.location.href = cartPage + (cartPage.indexOf('?') > -1 ? '&' : '?') + 'quantity=' + (qtyInput ? qtyInput.value : (buy.getAttribute('data-vv-sel-qty') || '1')); return; }
      /* otherwise the native form submit posts to /cart/add */
    });
  });

  /* Tabs */
  Q('[data-vv-tabs]').forEach(function (tabs) {
    var heads = qsa(tabs, '[data-vv-tab]'), panes = qsa(tabs, '[data-vv-pane]');
    heads.forEach(function (h) {
      h.addEventListener('click', function () {
        var i = h.getAttribute('data-vv-tab');
        heads.forEach(function (x) { x.setAttribute('aria-selected', x === h ? 'true' : 'false'); });
        panes.forEach(function (p) {
          p.hidden = p.getAttribute('data-vv-pane') !== i;
          qsa(p, 'video').forEach(function (v) { if (p.hidden) { v.pause(); } else { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } });
        });
      });
    });
  });

  /* Lazy videos: the file is only requested when the video comes within 400px of the screen; autoplay ones play in view and pause out of view */
  var lazyVids = Q('video[data-vv-lazy]');
  if (lazyVids.length) {
    var loadVid = function (v) {
      if (v.__vvLoaded) return; v.__vvLoaded = true;
      qsa(v, 'source[data-src]').forEach(function (so) { so.src = so.getAttribute('data-src'); });
      if (v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      v.load();
    };
    var playVid = function (v) { if (v.hasAttribute('data-vv-autoplay') && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } };
    if (!('IntersectionObserver' in window)) { lazyVids.forEach(function (v) { loadVid(v); playVid(v); }); }
    else {
      var near = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { loadVid(e.target); near.unobserve(e.target); } }); }, { rootMargin: '400px 0px' });
      var seen = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { loadVid(v); playVid(v); } else if (!v.paused) { v.pause(); } }); }, { threshold: 0.15 });
      lazyVids.forEach(function (v) { near.observe(v); seen.observe(v); });
    }
  }

  /* Trustpilot boxes added after the bootstrap script ran (theme editor, sections loaded later) */
  Q('.trustpilot-widget').forEach(function (el) {
    if (window.Trustpilot && !el.querySelector('iframe')) { try { window.Trustpilot.loadFromElement(el, true); } catch (err) {} }
  });

  /* Tab videos: unmute pill (Hike "Tap to unmute") */
  Q('[data-vv-unmute]').forEach(function (btn) {
    var wrap = btn.closest('.vv-video'); var v = wrap ? qs(wrap, 'video') : null;
    if (!v) return;
    btn.addEventListener('click', function () {
      v.muted = !v.muted; if (!v.muted) { v.volume = 1; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      btn.textContent = v.muted ? btn.getAttribute('data-vv-on') : btn.getAttribute('data-vv-off');
    });
  });

  /* Gallery: thumbs + arrows */
  Q('[data-vv-gallery]').forEach(function (g) {
    var main = qs(g, '[data-vv-gallery-main]');
    var thumbs = qsa(g, '[data-vv-thumb]');
    var idx = 0;
    function show(i) {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === idx); });
      if (thumbs[idx].scrollIntoView) { try { thumbs[idx].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {} }
      var th = thumbs[idx], vsrc = th.getAttribute('data-vv-video'), vid = qs(g, '[data-vv-gallery-video]');
      if (vsrc && vid) {
        if (main) main.hidden = true;
        if (vid.getAttribute('src') !== vsrc) vid.setAttribute('src', vsrc);
        vid.hidden = false; var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
      } else {
        if (vid) { vid.pause(); vid.hidden = true; }
        if (main) { main.hidden = false; main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = th.getAttribute('data-vv-full') || th.src; main.alt = th.alt; }
      }
    }
    thumbs.forEach(function (th, k) { th.addEventListener('click', function () { show(k); }); });
    var prev = qs(g, '[data-vv-prev]'), next = qs(g, '[data-vv-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
  });

  /* Before & Afters slider: arrows + dots */
  Q('[data-vv-slider]').forEach(function (wrap) {
    var track = qs(wrap, '[data-vv-track]');
    var items = track ? qsa(track, '[data-vv-slide]') : [];
    var dots = qs(wrap, '[data-vv-dots]');
    if (!track || !items.length) return;
    if (dots) items.forEach(function () { var i = document.createElement('i'); dots.appendChild(i); });
    function step() { var cs = getComputedStyle(track); return items[0].getBoundingClientRect().width + (parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0); }
    function paint() {
      if (!dots) return;
      var c = Math.round(track.scrollLeft / step());
      qsa(dots, 'i').forEach(function (d, k) { d.classList.toggle('is-on', k === c); });
    }
    var prev = qs(wrap, '[data-vv-prev]'), next = qs(wrap, '[data-vv-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    paint();
  });

  /* Reviews: load more */
  Q('[data-vv-reviews]').forEach(function (r) {
    var more = qs(r, '[data-vv-more]');
    if (!more) return;
    more.addEventListener('click', function (e) {
      e.preventDefault();
      qsa(r, '[data-vv-rev][hidden]').slice(0, 4).forEach(function (x) { x.hidden = false; });
      if (!qsa(r, '[data-vv-rev][hidden]').length) more.hidden = true;
    });
  });

  /* Countdown bar: counts to a fixed ISO date, or to local midnight every day when no date is set */
  Q('[data-vv-countdown]').forEach(function (cd) {
    var iso = cd.getAttribute('data-vv-countdown');
    var h = qs(cd, '[data-vv-h]'), m = qs(cd, '[data-vv-m]'), s = qs(cd, '[data-vv-s]');
    function target() {
      if (iso) { var d = new Date(iso); if (!isNaN(d)) return d; }
      var t = new Date(); t.setHours(24, 0, 0, 0); return t;
    }
    function tick() {
      var diff = Math.max(0, target() - new Date());
      var hh = Math.floor(diff / 36e5), mm = Math.floor(diff % 36e5 / 6e4), ss = Math.floor(diff % 6e4 / 1e3);
      if (h) h.textContent = pad(hh); if (m) m.textContent = pad(mm); if (s) s.textContent = pad(ss);
    }
    tick(); setInterval(tick, 1000);
  });

  /* Reservation timer: N minutes from first view, remembered for the session */
  Q('[data-vv-timer]').forEach(function (el) {
    var mins = parseInt(el.getAttribute('data-vv-timer'), 10) || 10;
    var key = 'vv-timer-end';
    var end;
    try { end = parseInt(sessionStorage.getItem(key), 10); } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, String(end)); } catch (e) {} diff = end - Date.now(); }
      el.textContent = pad(Math.floor(diff / 60000)) + ':' + pad(Math.floor(diff % 60000 / 1000));
    }
    tick(); setInterval(tick, 1000);
  });

  /* Ship date. Mode "sendes": ships today before the weekday cutoff, otherwise the next weekday (i dag / i morgen / man 12. okt). Mode "levert": today + N days, moved off weekends. */
  Q('[data-vv-shipby]').forEach(function (el) {
    var days = parseInt(el.getAttribute('data-vv-shipby'), 10) || 0;
    var mode = el.getAttribute('data-vv-ship-mode') || 'levert';
    var cutoff = parseInt(el.getAttribute('data-vv-ship-cutoff'), 10); if (isNaN(cutoff)) cutoff = 13;
    var now = new Date(), d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (mode === 'sendes') {
      if (d.getDay() === 0 || d.getDay() === 6 || now.getHours() >= cutoff) d.setDate(d.getDate() + 1);
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    } else {
      d.setDate(d.getDate() + (days || 3));
      if (d.getDay() === 6) d.setDate(d.getDate() + 2); else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    }
    var diffDays = Math.round((d - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
    var wd = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'][d.getDay()];
    var mo = ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'][d.getMonth()];
    el.textContent = (mode === 'sendes' && diffDays === 0) ? 'i dag' : (mode === 'sendes' && diffDays === 1) ? 'i morgen' : wd + ' ' + d.getDate() + '. ' + mo;
  });

  /* Cart builder (pack page), two steps: 1 covers (gallery follows the chosen cover), 2 pillows + set + totals. Cart permalink checkout. */
  Q('[data-vv-cart]').forEach(function (cart) {
    var variant = cart.getAttribute('data-vv-cart-variant');
    var unit = parseFloat(cart.getAttribute('data-vv-cart-price')) || 0;
    var packPrice = parseFloat(cart.getAttribute('data-vv-cart-pack-price')) || unit;
    var packMin = parseInt(cart.getAttribute('data-vv-cart-pack-min'), 10) || 2;
    var maxQty = parseInt(cart.getAttribute('data-vv-cart-max'), 10) || 4;
    var coverOff = parseFloat(cart.getAttribute('data-vv-cart-cover-off')) || 0;
    var base = cart.getAttribute('data-vv-cart-checkout') || '/cart/';
    var emptyText = cart.getAttribute('data-vv-cart-empty') || '';
    var mainImage = cart.getAttribute('data-vv-cart-image') || '';
    var q = parseInt((window.location.search.match(/[?&]quantity=(\d+)/) || [])[1], 10);
    var qty = Math.min(Math.max(isNaN(q) ? 1 : q, 0), maxQty);
    var step = 1;
    var covers = qsa(cart, '[data-vv-cover]').map(function (row) { return { row: row, id: row.getAttribute('data-vv-variant'), price: parseFloat(row.getAttribute('data-vv-price')) || 0, name: row.getAttribute('data-vv-name'), image: row.getAttribute('data-vv-image'), qty: 0 }; });
    var fmt = function (n) { return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'; };
    var main = qs(cart, '[data-vv-gallery-main]');
    var thumbs = qsa(cart, '[data-vv-thumb]');
    function showImage(src) {
      if (!main || !src) return;
      main.src = src;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', (t.getAttribute('data-vv-full') || t.src) === src); });
    }
    function showStep(n) {
      step = n;
      qsa(cart, '[data-vv-step]').forEach(function (p) { p.hidden = p.getAttribute('data-vv-step') !== String(n); });
      var no = qs(cart, '[data-vv-stepno]'); if (no) no.textContent = n + '/2';
      var back = qs(cart, '[data-vv-back]');
      if (back) { if (n === 2) { back.setAttribute('data-vv-href', back.getAttribute('href')); back.setAttribute('href', '#'); } else if (back.getAttribute('data-vv-href')) { back.setAttribute('href', back.getAttribute('data-vv-href')); } }
      if (n === 2) showImage(thumbs.length ? (thumbs[0].getAttribute('data-vv-full') || thumbs[0].src) : '');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function render() {
      var per = qty >= packMin ? packPrice : unit;
      var off = qty > 0 ? coverOff : 0;
      var mainOut = qs(cart, '[data-vv-stepper="main"] [data-vv-qty]'); if (mainOut) mainOut.textContent = qty;
      var mainRow = qs(cart, '.vv-cb__row--main'); if (mainRow) mainRow.classList.toggle('is-on', qty > 0);
      var uc = qs(cart, '[data-vv-unit-compare]'), up = qs(cart, '[data-vv-unit-price]');
      if (uc) uc.textContent = qty >= packMin ? fmt(unit) : '';
      if (up) up.textContent = fmt(per);
      var upsell = qs(cart, '[data-vv-upsell]'); if (upsell) upsell.hidden = !(qty > 0 && qty < packMin);
      var value = qty * unit, pay = qty * per, lines = [], nCovers = 0;
      if (qty > 0) lines.push('<li>' + (mainImage ? '<img src="' + mainImage + '" alt="">' : '') + '<span>' + qty + ' × Komfortputen</span><b>' + (per < unit ? '<s>' + fmt(qty * unit) + '</s>' : '') + fmt(pay) + '</b></li>');
      covers.forEach(function (cv) {
        var out = qs(cv.row, '[data-vv-qty]'); if (out) out.textContent = cv.qty;
        cv.row.classList.toggle('is-on', cv.qty > 0);
        var cp = qs(cv.row, '[data-vv-cover-price]'); if (cp) cp.textContent = fmt(cv.price - off);
        if (cv.qty > 0) { nCovers += cv.qty; value += cv.qty * cv.price; pay += cv.qty * (cv.price - off); lines.push('<li>' + (cv.image ? '<img src="' + cv.image + '" alt="">' : '') + '<span>' + cv.qty + ' × ' + cv.name + '</span><b>' + (off ? '<s>' + fmt(cv.qty * cv.price) + '</s>' : '') + fmt(cv.qty * (cv.price - off)) + '</b></li>'); }
      });
      var set = qs(cart, '[data-vv-set]'); if (set) set.innerHTML = lines.length ? lines.join('') : '<li class="is-empty">' + emptyText + '</li>';
      var s1 = qs(cart, '[data-vv-step1-text]'); if (s1) s1.textContent = nCovers ? 'Fortsett med ' + nCovers + (nCovers === 1 ? ' trekk' : ' trekk') : 'Fortsett';
      var save = value - pay, pct = value ? Math.round(save / value * 100) : 0;
      var tv = qs(cart, '[data-vv-total-value]'), ts = qs(cart, '[data-vv-total-save]'), tp = qs(cart, '[data-vv-total-pct]'), tpay = qs(cart, '[data-vv-total-pay]'), tpay2 = qs(cart, '[data-vv-total-pay2]');
      if (tv) tv.textContent = save > 0 ? fmt(value) : '';
      if (ts) ts.textContent = save > 0 ? '−' + fmt(save) : '0 kr';
      if (tp) tp.textContent = save > 0 ? '−' + pct + ' %' : '';
      if (tpay) tpay.textContent = fmt(pay);
      if (tpay2) tpay2.textContent = fmt(pay);
      var items = [];
      if (qty > 0) items.push(variant + ':' + qty);
      covers.forEach(function (cv) { if (cv.qty > 0) items.push(cv.id + ':' + cv.qty); });
      var btn = qs(cart, '[data-vv-checkout]');
      if (btn) { btn.href = base + items.join(','); btn.setAttribute('aria-disabled', items.length ? 'false' : 'true'); var tx = qs(btn, '[data-vv-checkout-text]'); if (tx) tx.textContent = items.length ? (btn.getAttribute('data-vv-label') || tx.textContent) : 'Velg minst én pute'; }
    }
    var mainStep = qs(cart, '[data-vv-stepper="main"]');
    if (mainStep) {
      qs(mainStep, '[data-vv-inc]').addEventListener('click', function () { qty = Math.min(maxQty, qty + 1); render(); });
      qs(mainStep, '[data-vv-dec]').addEventListener('click', function () { qty = Math.max(0, qty - 1); render(); });
    }
    var ups = qs(cart, '[data-vv-upsell]'); if (ups) ups.addEventListener('click', function () { qty = Math.min(maxQty, Math.max(qty, packMin)); render(); });
    covers.forEach(function (cv) {
      qs(cv.row, '[data-vv-inc]').addEventListener('click', function () { cv.qty = Math.min(4, cv.qty + 1); showImage(cv.image); render(); });
      qs(cv.row, '[data-vv-dec]').addEventListener('click', function () { cv.qty = Math.max(0, cv.qty - 1); render(); });
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t.getAttribute('data-vv-full') || t.src); }); });
    qsa(cart, '[data-vv-more]').forEach(function (btn) { btn.addEventListener('click', function () { var g = btn.closest('[data-vv-group]') || cart; qsa(g, '[data-vv-more-row]').forEach(function (r) { r.hidden = false; }); btn.hidden = true; }); });
    var nxt = qs(cart, '[data-vv-next-step]'); if (nxt) nxt.addEventListener('click', function () { showStep(2); });
    var skip = qs(cart, '[data-vv-skip]'); if (skip) skip.addEventListener('click', function () { covers.forEach(function (cv) { cv.qty = 0; }); render(); showStep(2); });
    var edit = qs(cart, '[data-vv-edit]'); if (edit) edit.addEventListener('click', function () { showStep(1); });
    var backBtn = qs(cart, '[data-vv-back]'); if (backBtn) backBtn.addEventListener('click', function (e) { if (step === 2) { e.preventDefault(); showStep(1); } });
    render();
  });

  /* Sticky bar: show after the hero scrolls out; on desktop it hangs under the sticky countdown bar */
  var sticky = one('[data-vv-sticky]');
  if (sticky) {
    var cdBar = document.querySelector('.vv-cd');
    function cdH() { document.documentElement.style.setProperty('--vv-cd-h', (cdBar ? cdBar.getBoundingClientRect().height : 0) + 'px'); }
    cdH(); window.addEventListener('resize', cdH);
    /* what has to scroll out first: a marked element, the hero, or (a page that starts at the buy box) the buy box's button */
    var mode = sticky.getAttribute('data-vv-sticky-after') || 'hero';
    var trigger = null;
    if (mode !== 'always') {
      trigger = document.querySelector('[data-vv-sticky-trigger]');
      if (!trigger && mode === 'hero') trigger = document.querySelector('.vv-offer-hero');
      if (!trigger) trigger = document.querySelector('.vv-buy [data-vv-cta]');
    }
    document.body.classList.add('vv-has-sticky');
    function check() {
      if (!trigger) { sticky.classList.add('is-on'); return; }
      sticky.classList.toggle('is-on', trigger.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* Smooth scroll for in-page CTAs */
  /* CTA anchors: land the buy box where the section's settings say (gallery, title or package choice), under whatever is sticky at the top */
  function vvLandingTarget(section) {
    var phone = window.matchMedia('(max-width: 859px)').matches;
    var mode = section.getAttribute(phone ? 'data-vv-land-m' : 'data-vv-land') || 'top';
    if (mode === 'tiers') return qs(section, '.vv-divider') || qs(section, '.vv-buy__title') || section;
    if (mode === 'title') return qs(section, '.vv-buy__title') || section;
    return section;
  }
  function vvStickyTop() {
    var h = 0, cd = document.querySelector('.vv-cd'); if (cd) h += cd.getBoundingClientRect().height;
    if (window.matchMedia('(min-width: 860px)').matches) {
      var bar = document.querySelector('.vv-sticky');
      if (bar) { var shown = bar.classList.contains('is-on'); if (!shown) bar.style.display = 'flex'; h += bar.getBoundingClientRect().height; if (!shown) bar.style.display = ''; }
    }
    return h;
  }
  Q('a[href^="#vv-"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var section = document.getElementById(a.getAttribute('href').slice(1));
      if (!section) return;
      e.preventDefault();
      var target = section.hasAttribute('data-vv-land') ? vvLandingTarget(section) : section;
      var top = target.getBoundingClientRect().top + window.pageYOffset - vvStickyTop() - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  });

  /* Listicle: reading-progress strip, publisher-bar height (for the sticky trick), phone sticky bar, countdown height when no offer sticky bar is present */
  (function () {
    function heights() {
      var cd = document.querySelector('.vv-cd'), pub = document.querySelector('.vv-pub');
      document.documentElement.style.setProperty('--vv-cd-h', (cd ? cd.getBoundingClientRect().height : 0) + 'px');
      if (pub) document.documentElement.style.setProperty('--vv-pub-h', pub.getBoundingClientRect().height + 'px');
    }
    heights();
    if (!window.__vvHeightsBound) { window.__vvHeightsBound = true; window.addEventListener('resize', heights); window.addEventListener('load', heights); }
    var bar = one('[data-vv-progress-bar]');
    if (bar) {
      function pr() { var h = document.documentElement; var max = h.scrollHeight - window.innerHeight; bar.style.width = (max > 0 ? Math.min(100, Math.max(0, window.scrollY / max * 100)) : 0) + '%'; }
      window.addEventListener('scroll', pr, { passive: true }); pr();
    }
    var ls = one('[data-vv-lsticky]');
    if (ls) {
      var trig = document.querySelector('[data-vv-lsticky-trigger]');
      document.body.classList.add('vv-has-lsticky');
      function lc() { ls.classList.toggle('is-on', !trig || trig.getBoundingClientRect().bottom < 0); }
      window.addEventListener('scroll', lc, { passive: true }); lc();
    }
  })();
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
